import { mockApiImpl } from "./impl";

export const cms = {
  adminListEvents: mockApiImpl.adminListEvents,
  adminCreateEvent: mockApiImpl.adminCreateEvent,
  adminUpdateEvent: mockApiImpl.adminUpdateEvent,
  adminDeleteEvent: mockApiImpl.adminDeleteEvent,
  adminUploadEventImage: mockApiImpl.adminUploadEventImage,
  adminGetEventNotifyPreview: mockApiImpl.adminGetEventNotifyPreview,
  adminSendEventAnnouncement: mockApiImpl.adminSendEventAnnouncement,
  getTestimonials: mockApiImpl.getTestimonials,
  getHomeContent: mockApiImpl.getHomeContent,
  getAboutContent: mockApiImpl.getAboutContent,
  getLegalContent: mockApiImpl.getLegalContent,
  adminListTestimonials: mockApiImpl.adminListTestimonials,
  adminCreateTestimonial: mockApiImpl.adminCreateTestimonial,
  adminUpdateTestimonial: mockApiImpl.adminUpdateTestimonial,
  adminDeleteTestimonial: mockApiImpl.adminDeleteTestimonial,
  adminUploadTestimonialImage: mockApiImpl.adminUploadTestimonialImage,
  adminGetHomeContent: mockApiImpl.adminGetHomeContent,
  adminUpdateHomeContent: mockApiImpl.adminUpdateHomeContent,
  adminGetLegalContent: mockApiImpl.adminGetLegalContent,
  adminUpdateLegalContent: mockApiImpl.adminUpdateLegalContent,
  adminUploadHomeHeroImage: mockApiImpl.adminUploadHomeHeroImage,
  adminUploadHomeAboutImage: mockApiImpl.adminUploadHomeAboutImage,
  adminGetAboutContent: mockApiImpl.adminGetAboutContent,
  adminUpdateAboutContent: mockApiImpl.adminUpdateAboutContent,
  adminUploadAboutHeroImage: mockApiImpl.adminUploadAboutHeroImage,
  adminUploadAboutFounderImage: mockApiImpl.adminUploadAboutFounderImage,
  adminUploadAboutGalleryImage: mockApiImpl.adminUploadAboutGalleryImage,
  adminUploadAboutLeadershipImage: mockApiImpl.adminUploadAboutLeadershipImage,
  adminResetAboutContentToSeed: mockApiImpl.adminResetAboutContentToSeed,
  adminResetTestimonialsToSeed: mockApiImpl.adminResetTestimonialsToSeed,
  adminResetHomeContentToSeed: mockApiImpl.adminResetHomeContentToSeed,
  getProgramsContent: mockApiImpl.getProgramsContent,
  getImpactContent: mockApiImpl.getImpactContent,
  adminPublishHomeContent: mockApiImpl.adminPublishHomeContent,
  adminPublishAboutContent: mockApiImpl.adminPublishAboutContent,
  adminPublishLegalContent: mockApiImpl.adminPublishLegalContent,
  adminPublishProgramsContent: mockApiImpl.adminPublishProgramsContent,
  adminPublishImpactContent: mockApiImpl.adminPublishImpactContent,
  adminGetHomeRevisions: mockApiImpl.adminGetHomeRevisions,
  adminRestoreHomeRevision: mockApiImpl.adminRestoreHomeRevision,
  adminGetAboutRevisions: mockApiImpl.adminGetAboutRevisions,
  adminRestoreAboutRevision: mockApiImpl.adminRestoreAboutRevision,
  adminGetLegalRevisions: mockApiImpl.adminGetLegalRevisions,
  adminRestoreLegalRevision: mockApiImpl.adminRestoreLegalRevision,
  adminGetProgramsRevisions: mockApiImpl.adminGetProgramsRevisions,
  adminRestoreProgramsRevision: mockApiImpl.adminRestoreProgramsRevision,
  adminGetImpactRevisions: mockApiImpl.adminGetImpactRevisions,
  adminRestoreImpactRevision: mockApiImpl.adminRestoreImpactRevision,
  adminGetProgramsContent: mockApiImpl.adminGetProgramsContent,
  adminUpdateProgramsContent: mockApiImpl.adminUpdateProgramsContent,
  adminGetImpactContent: mockApiImpl.adminGetImpactContent,
  adminUpdateImpactContent: mockApiImpl.adminUpdateImpactContent,
  adminListCmsMedia: mockApiImpl.adminListCmsMedia,
  adminUploadCmsMedia: mockApiImpl.adminUploadCmsMedia,
  adminUpdateCmsMedia: mockApiImpl.adminUpdateCmsMedia,
  adminDeleteCmsMedia: mockApiImpl.adminDeleteCmsMedia,
  adminSeedCmsMediaDefaults: mockApiImpl.adminSeedCmsMediaDefaults,
};
